module.exports = __webpack_public_path__ + "images/3a1db9145cfef754ce6c4b43ef495c7555303b24c700319fe9c9364d45146401.svg";